import useAxios, { mutate } from 'hooks/useAxios'
import React, { useState } from 'react'
import { Button, Form, Input } from 'semantic-ui-react'
import { toast } from 'libs/toast'
import * as R from 'ramda'

import { getDateRangeByDateFilterType } from 'shared/components/DateRangePicker/utils'
import { useHistory } from 'react-router-dom'
import useUser from 'hooks/useUser'
import useSaveUserActivityLog, { REPORT_VIEW_ACTION_NAME } from 'hooks/useSaveUserActivityLog'
import useWorkspace from 'hooks/useWorkspace'
import { validateRequiredText } from 'libs/form-validation'
import ErrorText from 'shared/components/forms/ErrorText'

export default function ReportViewCreateModal({ modal: Modal, close }) {
  const history = useHistory()
  const saveUserActivityLog = useSaveUserActivityLog()
  const [viewNameInput, setViewNameInput] = useState('')
  const [nameError, setNameError] = useState('')

  const { fetch: createReportView, loading } = useAxios({
    url: 'reports/report-view-pages/',
    method: 'post',
    skip: true,
  })
  const workspaceToken = useWorkspace()
  const userInfo = useUser()
  const companyId = R.path(['selected_workspace', 'id'], userInfo)

  function handleNameChange(name) {
    setViewNameInput(name)
    if (nameError) {
      setNameError('')
    }
  }

  function handleSubmit() {
    const validationError = validateRequiredText('View name', viewNameInput)
    if (validationError) {
      setNameError(validationError)
      return
    }
    const trimmedName = viewNameInput.trim()
    const [startDate, endDate] = getDateRangeByDateFilterType(5)
    const data = {
      name: trimmedName,
      date_filter_type: 5,
      start_date: startDate,
      end_date: endDate,
      advanced_filters: {},
      metric: 'all',
      segments: [{ key: 'survey', attribute: null }],
    }

    createReportView({ data: data })
      .then((res) => {
        if (res.data) {
          close()
          toast.success('New view created!')

          mutate('reports/report-view-pages/')

          history.push({
            pathname: `/${workspaceToken}/reports/views/${res.data.token}/`,
            state: { reportViewName: res.data.name },
            search: '',
          })
          saveUserActivityLog({
            action: REPORT_VIEW_ACTION_NAME.created_view,
            statusCode: res.status,
            requestBody: data,
            target: `com_${companyId}`,
          })
        }
      })
      .catch((err) => {
        console.error(err)
        saveUserActivityLog({
          action: REPORT_VIEW_ACTION_NAME.created_view,
          statusCode: err.response.status,
          errorResponseBody: err.response.data,
          requestBody: data,
          target: `com_${companyId}`,
        })
        toast.error(
          'Uh oh. There was a problem creating the new view. Please try again or contact Simplesat support.'
        )
      })
  }

  return (
    <Modal size="tiny">
      <Modal.Header>Create new view</Modal.Header>
      <Modal.Content>
        <p>
          <a
            href="https://help.simplesat.io/en/articles/4218331-reports#save-a-report-as-a-view"
            target="_blank"
            rel="noreferrer"
          >
            <i className="icon far fa-book" />
            Learn more about report views
          </a>
        </p>
        <Form id="create-view-form" onSubmit={handleSubmit} noValidate>
          <Form.Field error={Boolean(nameError)}>
            <label>Name</label>
            <Input
              value={viewNameInput}
              onChange={(e) => handleNameChange(e.target.value)}
              placeholder="Report view name"
            />
            {nameError && <ErrorText>{nameError}</ErrorText>}
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close}>Cancel</Button>
        <Button type="submit" loading={loading} disabled={loading} primary form="create-view-form">
          Create view
        </Button>
      </Modal.Actions>
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/ReportView/ReportViewCreateModal/index.js